import { render, staticRenderFns } from "./insertCashBox.vue?vue&type=template&id=6a4e8938&"
import script from "./insertCashBox.vue?vue&type=script&lang=js&"
export * from "./insertCashBox.vue?vue&type=script&lang=js&"
import style0 from "./insertCashBox.vue?vue&type=style&index=0&id=6a4e8938&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports